import { Flex, Text } from '@chakra-ui/react'
import { AppContext, PopUpMessageContext } from '@hb/react'
import {
  coverageRequestField,
  FieldMapValue,
  InsuranceCoverageRequest,
  UpdateCallback,
  User,
  WithId,
} from '@hb/shared'
import { DocumentReference } from 'firebase/firestore'
import { useCallback, useContext } from 'react'
import { requestCoverage } from '../../../backend/functions/other'
import { SimpleForm } from '../../forms/FinalForm/SimpleForm'
import { DefaultModal } from '../../Modals/DefaultModal'

export const EditCoverageRequestModal = ({
  onClose,
  request,
  patientRef,
}: {
  onClose: () => void
  request: WithId<InsuranceCoverageRequest>
  patientRef: DocumentReference<User>
}) => {
  const { processResponse } = useContext(PopUpMessageContext)

  const { appName } = useContext(AppContext)
  const handleRequestNewPlan = useCallback(
    async (data: FieldMapValue): Promise<UpdateCallback> => {
      const { message, withCallInForm, sendEmail } = data
      try {
        await requestCoverage({
          patientId: patientRef.id,
          // assessmentId,
          appName,
          requestId: request.id,
          message: message ?? '',
          withCallInForm,
          sendEmail: !!sendEmail,
        })
      } catch (err: any) {
        return processResponse({
          error: err?.message || 'Error requesting coverage',
        })
      }
      onClose()
      return processResponse({ success: 'Coverage requested' })
    },
    [patientRef, processResponse, onClose, request, appName],
  )

  return (
    <DefaultModal
      isOpen
      overlayHeader
      onClose={onClose}
      size="xl"
      render={() => (
        <Flex py={4} px={2} w="100%" flexFlow="column">
          <Text px={3} fontFamily="Hero-New" fontSize="lg" lineHeight={1} color="gray.600">
            Edit Coverage Request
          </Text>
          <SimpleForm
            onSubmit={handleRequestNewPlan}
            field={coverageRequestField}
            value={request}
            boxProps={{ p: 0 }}
          />
        </Flex>
      )}
    />
  )
}
